import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'rcp-page-header',
  template: `
    <div class="rcp-page-header">
      <div class="rcp-page-header-content">
        <div class="rcp-page-header-crumbs">
          <ng-content select="rcp-breadcrumbs" />
        </div>

        <div class="rcp-page-header-info">
          <!-- todo RESTYLE: remove no-margin, because the _old_ styles need it to show the UI correctly -->
          <div class="rcp-page-header-title-container">
            <h1 class="rcp-page-header-title no-margin">
              {{ label() }}
            </h1>
            <ng-content select="[trailing-detail]" />
          </div>

          @if (description()) {
            <div class="rcp-page-header-description">
              {{ description() }}
            </div>
          }
        </div>
      </div>

      <div class="rcp-page-header-actions">
        <ng-content select="[actions]" />
      </div>
    </div>
  `,
  styles: `
    :host {
      display: flex;
    }

    .rcp-page-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1 0 auto;
      width: 100%; /* needed so flex-grow stays within boundaries */

      gap: var(--item-spacing-between-md);

      .rcp-page-header-crumbs,
      .rcp-page-header-actions {
        &:empty {
          display: none;
        }
      }

      .rcp-page-header-content {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        gap: var(--text-header-spacing);

        .rcp-page-header-info {
          display: flex;
          flex-direction: column;
          gap: var(--text-paragraph-spacing);

          .rcp-page-header-title-container {
            display: flex;
            align-items: center;
            gap: var(--item-spacing-between-md);

            .rcp-page-header-title {
              font-size: var(--font-size-header-1);
              font-weight: var(--font-weight-bold);
            }
          }
        }
      }

      .rcp-page-header-actions {
        flex: 0 0 auto;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageHeaderComponent {
  label = input.required<string>();
  description = input<string>();
}
